import { Component, OnInit, Inject } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import {
  PhotoModelComingFrom,
  ImplementInspectionImageViewModel,
  InspectedImplementsViewModel,
  GeneralQuestionImageViewModel,
  InspectImplementQuestionViewModel,
  InspectionObservationPointsViewModel,
  ObservationImagesViewModel,
  PreInspectionChecklistVM,
  CheckListImagesVM,
} from '../../inspections/inspection.model';
import { FileReaderEvent } from '../../setup-implement/setup-implement.component';
import { GETEditPhotoComponent } from '../edit-photo/edit-photo.component';
import { NewInspectionService } from '../../inspections/inpsection.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ImageList } from '../../FECR/FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { SaveImplementImageParams } from '../../setup-implement/setup-implement.model';
import { SetupImplementService } from '../../setup-implement/setup-implement.service';
import { Action } from 'rxjs/internal/scheduler/Action';
import { InterpretationService } from '../../../../modules/interpretation/interpretation.service';
import { BogieImageVM } from '../../../../shared/components/bogie-shim/bogie-shim-model';
import { heicTo } from 'heic-to';


@Component({
  selector: 'app-view-photo',
  templateUrl: './view-photo.component.html',
  styleUrls: ['./view-photo.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ])
    ]
    )]
})
export class GETViewPhotoComponent implements OnInit {

  photoLoading = true;
  photo: string;
  equipmentID: number
  //new FECR Code
  FECRAdditonalObsId: number;

  photoComingFrom: PhotoModelComingFrom;

  displayComponentImageType: boolean;
  showDeleteButton: boolean = true;
  showDrawButton: boolean = true;
  imgUrl: boolean = false;
  bogieImageId: number;
  viewMode: boolean = false;
  private inspectionImageModel: ImplementInspectionImageViewModel;
  private implementInspection: InspectedImplementsViewModel;



  private questionImageModel: GeneralQuestionImageViewModel;
  private questionModel: InspectImplementQuestionViewModel;


  private observationPoint: InspectionObservationPointsViewModel;
  private observationPointImage: ObservationImagesViewModel;


  private preChecklist: PreInspectionChecklistVM;
  private imageChecklist: CheckListImagesVM;
  private FEcrAdditonImage: ImageList;
  private imageUrl: string;
  constructor(private _dialogRef: MatDialogRef<GETViewPhotoComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _sanitizer: DomSanitizer,
    private _editPhotoDialog: MatDialog,
    private _inspectionService: NewInspectionService,
    private _loading: LoadingService,
    private notification: NotificationsService,
    private _implementService: SetupImplementService,
    private _interpService: InterpretationService
  ) { }

  ngOnInit() {
    this.photoComingFrom = this._data.comingFrom;
    if (this.photoComingFrom) {
      switch (this.photoComingFrom) {
        case PhotoModelComingFrom.InterpretationInspectionImages:
        case PhotoModelComingFrom.NewInspectionInspectionImages:
          this.inspectionImageModel = this._data.image;
          this.photo = this.inspectionImageModel.ImageData;
          this.implementInspection = this._data.implementInspection;
          this.photoLoading = false;
          break;
        case PhotoModelComingFrom.NewInspectionGeneralQuestionsImagesOnImplementLevel:
        case PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel:
          this.photo = this._data.image.ImageData;
          this.implementInspection = this._data.implementInspection;
          this.questionModel = this._data.question;
          this.questionImageModel = this._data.image;
          this.photoLoading = false;
          break;
        case PhotoModelComingFrom.NewInspectionObservationPointImageOnComponentLevel:
        case PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel:

          this.photo = this._data.image.ImageDataPath;
          this.observationPointImage = this._data.image;
          this.observationPoint = this._data.inspectionObservationPoint;
          this.photoLoading = false;
          this.imgUrl = this._data.ImageUrl;
          break;
        case PhotoModelComingFrom.PreCheckListQuestionImages:

          this.photo = this._data.imageChecklist.Image;
          this.imageChecklist = this._data.image;
          this.preChecklist = this._data.preChecklist
          this.photoLoading = false;
          break;
        case PhotoModelComingFrom.EquipmentDetails:

          this.photo = this._data.image;
          this.equipmentID = this._data.equipmentId;
          this.photoLoading = false;

          break;
        case PhotoModelComingFrom.FECRAdditionalObs:
          //console.log("THis_data", this._data)
          this.FEcrAdditonImage = this._data.image;
          this.photo = this.FEcrAdditonImage.Image;

          this.FECRAdditonalObsId = this._data.FECRAdditonalObsId;
          this.photoLoading = false;

          break;
        case PhotoModelComingFrom.DisplayComponentImageType:
          //console.log("THis_data", this._data)
          this.displayComponentImageType = true;
          this.photo = this._data.image;
          this.photoLoading = false;
          break;
        case PhotoModelComingFrom.ImplementImage:
          this.showDeleteButton = false;
          this.showDrawButton = false;
          this.photo = this._data.image;
          this.implementInspection = this._data.implementInspection;
          this.photoLoading = false;
          //this.imgUrl = true;
          this.imgUrl = this.photo.startsWith('http://') || this.photo.startsWith('https://');
          break;
        case PhotoModelComingFrom.BogieInspectionImageHistory:
          this.showDeleteButton = false;
          this.showDrawButton = false;
          this.photo = this._data.image;
          this.bogieImageId = this._data.Id;
          this.photoLoading = false;
          this.imgUrl = this._data.ImageUrl;
          this.viewMode = true;
          break;
        case PhotoModelComingFrom.BogieNewInspectionImage:
          this.showDeleteButton = true;
          this.showDrawButton = false;
          this.photo = this._data.image;
          this.bogieImageId = this._data.Id;
          this.photoLoading = false;
          this.imgUrl = this._data.ImageUrl;
          this.viewMode = true;
          break;
        case PhotoModelComingFrom.BogieInterpImage:
          this.showDeleteButton = true;
          this.showDrawButton = false;
          this.photo = this._data.image;
          this.bogieImageId = this._data.Id;
          this.photoLoading = false;
          this.imgUrl = this._data.ImageUrl;
          break;
        case PhotoModelComingFrom.BogieImageEquipmentPage:
          this.showDeleteButton = false;
          this.showDrawButton = false;
          this.photo = this._data.image;
          this.bogieImageId = this._data.Id;
          this.photoLoading = false;
          this.imgUrl = this._data.ImageUrl;
          this.viewMode = true;
          break;
        case PhotoModelComingFrom.AuditTrail:
          this.showDeleteButton = false;
          this.showDrawButton = false;
          this.photo = this._data.image;
          this.photoLoading = false;
          this.imgUrl = this._data.ImageUrl;
          this.viewMode = true;
          break;
        default: break;
      }

    }
  }

  onNoClick(): void {
    if (this.photoComingFrom === PhotoModelComingFrom.ImplementImage)
      this._dialogRef.close(false);
    else 
      this._dialogRef.close(true);
  }
  getPhoto() {

  }
  compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        let width, height;
        width = img.width;
        height = img.height;
        console.log('width', width)
        console.log('height', height)
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  updatePhoto(newPhoto: string) {
    this.imgUrl = false;
    this.photo = newPhoto;
    switch (this.photoComingFrom) {
      case PhotoModelComingFrom.DisplayComponentImageType:
        //console.log("THis_data", this._data)
        this.photo = this._data.image;
        this.photoLoading = false;
        // let compart_attach_auto = this._data._data.this._data
        this._inspectionService.updateComponentImage(this._data.compart_attach_auto, newPhoto, this._data.imageId).subscribe(r => {
          // console.log('r',r)
          this.notification.success("Image Updated Successfully.")
          this.success();
          //this._dialogRef.close(true);
        });
        break;
      case PhotoModelComingFrom.NewInspectionInspectionImages:
        this.inspectionImageModel.ImageData = newPhoto;
        this.photo = this.inspectionImageModel.ImageData;
        this.photoLoading = false;
        break;
      case PhotoModelComingFrom.EquipmentDetails:
        //Save equipment Image
        this._inspectionService.updateEquipmentImage(this._data.equipmentId, newPhoto).subscribe(r => {
          console.log('r', r)
          this._dialogRef.close(true);
        });
        break;
      case PhotoModelComingFrom.InterpretationInspectionImages:
        this._inspectionService.updateInpsectionImage(this.inspectionImageModel.ImageId, newPhoto).subscribe(r => {
          this._dialogRef.close(true);
        });
        break;
      case PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel:
        this._inspectionService.updateInpsectionImage(this.questionImageModel.ImageId, newPhoto).subscribe(r => {
          this._dialogRef.close(true);
        });
        break;
      case PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel:
        this._inspectionService.updateObservationPointImages(this.observationPointImage.Id, newPhoto).subscribe(r => {
          this.loadingRow = false;
          this._dialogRef.close(true);
        });
        break;
      case PhotoModelComingFrom.NewInspectionObservationPointImageOnComponentLevel:
        this.observationPointImage.ImageData = newPhoto;
        break;
      case PhotoModelComingFrom.NewInspectionGeneralQuestionsImagesOnImplementLevel:
        const imageModel = this.questionModel.Image.find(i => i.ImageData === this.questionImageModel.ImageData);
        imageModel.ImageData = newPhoto;
        this.photoLoading = false;
        break;
      case PhotoModelComingFrom.PreCheckListQuestionImages:
        this._inspectionService.updatePreInpsectionCheckListImage(this._data.imageChecklist.AnswerId, newPhoto, this._data.imageChecklist.Id).subscribe(r => {
          this._dialogRef.close(true);
        });
        break;
      case PhotoModelComingFrom.FECRAdditionalObs:

        this._inspectionService.updateFECRAdditionObsImage(this.FEcrAdditonImage.Id, newPhoto).subscribe(r => {
          console.log('r', r)
          this._dialogRef.close(true);
        });


        break;
      case PhotoModelComingFrom.ImplementImage:
        var saveParams: SaveImplementImageParams = new SaveImplementImageParams();
        saveParams.GETAuto = this._data.implementInspection;
        saveParams.ImageData = this.imageUrl;
        this._implementService.SaveImplementImage(saveParams).subscribe(r => {
          if (r) {
            this.notification.success('Image Save Successfully.');
          }
        });
        this._dialogRef.close(newPhoto);
        break;
      case PhotoModelComingFrom.BogieInterpImage:
        var updateParams: BogieImageVM = new BogieImageVM();
        updateParams.ImageId = this.bogieImageId,
          updateParams.Image = newPhoto

        this._interpService.updateBogieShimPhoto(updateParams).subscribe(r => {
          console.log('r', r)
          this._dialogRef.close({ Action: 'updateInterp', Data: r });
        });
        break;
      default: break;
    }
  }

  private success() {
    this._loading.finishedLoading();
    this._dialogRef.close(true);
  }
  deletePhoto() {
    this._loading.startLoading();

    switch (this.photoComingFrom) {
      case PhotoModelComingFrom.InterpretationInspectionImages:
        this._inspectionService.deleteInspectionImage(this.implementInspection.ImplementInspectionId, this.inspectionImageModel.ImageId)
          .subscribe(i => {
            this.success();
          });
        break;
      case PhotoModelComingFrom.DisplayComponentImageType:
        //console.log("THis_data", this._data)
        this.photo = this._data.image;
        this.photoLoading = false;

        // let compart_attach_auto = this._data._data.this._data
        //this._inspectionService.updateComponentImage(this._data.compart_attach_auto, newPhoto).subscribe(r => {
        this._inspectionService.deleteComponentImage(this._data.compart_attach_auto).subscribe(r => {

          // console.log('r',r)
          this.notification.success("Image Deleted Successfully.")
          this.success();
          //this._dialogRef.close(true);
        });
        break;

      case PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel:
        this._inspectionService.deleteInspectionImage(this.implementInspection.ImplementInspectionId, this.questionImageModel.ImageId)
          .subscribe(i => {
            this.success();
          });
        break;
      case PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel:
        this._inspectionService.deleteObservationPointImage(this.observationPointImage.Id).subscribe(r => {
          this.success();
        });
        break;
      // New Inspection does not need to make a http request
      // and I did not obtain a unique picture Id
      // This may have bugs in the furture
      // eg uploaded two same pics will delete all
      case PhotoModelComingFrom.NewInspectionInspectionImages:
        this.implementInspection.InspectionImages =
          this.implementInspection.InspectionImages.filter(i => i.ImageData !== this.inspectionImageModel.ImageData);
        this._dialogRef.close();
        break;
      case PhotoModelComingFrom.NewInspectionGeneralQuestionsImagesOnImplementLevel:
        this.questionModel.Image = this.questionModel.Image.filter(i => i.ImageData !== this.questionImageModel.ImageData);
        this._dialogRef.close();
        break;
      case PhotoModelComingFrom.NewInspectionObservationPointImageOnComponentLevel:
        this.observationPoint.ObservationImages = this.observationPoint.ObservationImages.filter(i => i.ImageData !== this.photo);
        this._dialogRef.close();
        break;


      case PhotoModelComingFrom.PreCheckListQuestionImages:
        this._inspectionService.deleteChecklistAnswerImage(this._data.imageChecklist.Id).subscribe(r => {
          this.success();
        });
        this.preChecklist.Images = this.preChecklist.Images.filter(i => i.Image !== this.photo);
        this._dialogRef.close();

        break;

      case PhotoModelComingFrom.FECRAdditionalObs:
        this._inspectionService.deleteFECRAdditionaObsImage(this.FEcrAdditonImage.Id).subscribe(r => {
          this.success();
        });
        break;
      case PhotoModelComingFrom.BogieNewInspectionImage:
        this._dialogRef.close({ Action: 'delete' });
        break;
      case PhotoModelComingFrom.BogieInterpImage:
        this._interpService.deleteBogieShimImage(this.bogieImageId).subscribe(r => {
          this._dialogRef.close({ Action: 'deleteInerp' });
        });
        break;
      default: break;
    }
  }


  loadingRow: boolean = false;
  // editPhoto() {
  //   const editPhotoModalRef = this._editPhotoDialog.open(GETEditPhotoComponent, {
  //     data: { photoWithExt: this.imgUrl ? this.photo : 'data:image/png;base64,' + this.photo }
  //   });
  //   editPhotoModalRef.afterClosed().subscribe(res => {
  //     if (res != null) {
  //       this.photo = res.photo;
  //       this.loadingRow = true;
  //       this.updatePhoto(res.photo);
  //     }
  //   });
  // }

  editPhoto() {
    this.loadingRow = true;
    if (!this.imgUrl) {
      const base64Image = 'data:image/png;base64,' + this.photo;
      this.openEditModal(base64Image);
      this.loadingRow = false;
      return;
    }
    this._interpService.getBase64Image(this.photo).subscribe({
      next: (res: string) => {
        const base64Image = 'data:image/png;base64,' + res;
        this.openEditModal(base64Image);
        this.loadingRow = false;
      },
      error: (err) => {
        this.loadingRow = false;
        console.error('Error converting image:', err);
        this.notification?.error?.(
          'Error',
          'Unable to load image for editing.'
        );
      }
    });
  }

  openEditModal(base64Image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(GETEditPhotoComponent, {
      data: { photoWithExt: base64Image }
    });

    editPhotoModalRef.afterClosed().subscribe(res => {
      if (res != null) {
        this.photo = res.photo;
        this.loadingRow = true;
        this.updatePhoto(res.photo);
      }
    });
  }

  async replacePhotoClicked(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  this.photoLoading = true;
  // this._cdr.detectChanges();

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {

          if (res) {

            this.imageUrl = res;
            this.updatePhoto(res.split(',')[1]);

          }

        })
        .catch(err => {

          this.photoLoading = false;
          console.error(err);

        });

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    this.photoLoading = false;

    console.error("HEIC conversion failed", err);

    this.notification.error(
      "Error",
      "Unable to update the photo. Please contact support."
    );

  }

  event.target.value = null;

}
  
  // replacePhotoClicked(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     //this._cdr.detectChanges();
  //     let file = event.target.files[0];
  //     const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl)
  //           .then((res: string) => {
  //             if (res) {
  //              this.imageUrl = res;
  //               this.updatePhoto(res.split(',')[1]);
  //             }
  //           })
  //       };
  //       reader.readAsDataURL(f);
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //        blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         this.photoLoading = false;
  //         console.error("HEIC conversion failed", err);
  //         this.notification.error('Error', 'Unable to update the photo. Please contact support.');
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

  // replacePhotoClicked(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     // this.updatePhoto(event.target.files[0]);
  //     const reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]);
  //     reader.onload = (event: any) => {
  //       //this.updatePhoto(event.target.result.split(',')[1]);
  //       const imageUrl = (event.target.result);
  //       //resize photo
  //       this.compressImage(imageUrl).then((res: string) => {
  //         // console.log("imageUrl", res)
  //         if (res) {
  //           //console.log('res', res)
  //           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
  //           this.imageUrl = res;
  //           this.updatePhoto(res.split(',')[1]);
  //         }
  //       })
  //     };
  //   }
  // }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
}
